import AdHandler from "./AdHandler";
import EventHandler from "./EventHandler";
import i18nHandler from "./i18nHandler";
import PauseHandler from "./PauseHandler";
import ResizeHandler from "./ResizeHandler";
import UserHandler from "./UserHandler";
export default {
    AdHandler: AdHandler,
    EventHandler: EventHandler,
    i18nHandler: i18nHandler,
    PauseHandler: PauseHandler,
    ResizeHandler: ResizeHandler,
    UserHandler: UserHandler,
};
